@if (department) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()" />
      </div>
      <div class="dialogContent">
        <div>
          <app-dialog-input-title title="Afdelingsnavn"
          [required]="true"></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="department.departmentName" />
        </div>
        <app-dialog-input-title title="Afdelingsnummer"
        [required]="true"></app-dialog-input-title>
        <input type="text" class="Textbox" [(ngModel)]="department.departmentNumber" />
      </div>
      <div class="dialogFooter">
        <app-save-button [disabled]="!department.departmentName.trim() || !department.departmentNumber"
          [clickEvent]="saveChanges.bind(this)">
        </app-save-button>
        <app-delete-button [clickEvent]="deleteCourse.bind(this)">
        </app-delete-button>
      </div>
    </div>
  }
